(function () {
  'use strict';
 
  /* ── Sabitler ─────────────────────────────────────────────── */
  const LS_KEY    = 'swistt_favorites_v2';
  const LS_RECENT = 'swistt_recently_v1';
  const LS_CAT    = 'swistt_cat';          // customer access token
  const ROUTES    = window.FavShopRoutes || {};
  const SC        = window.ShopCustomer  || {};
  const API_VER   = '2024-10';
 
  /* ── Yardımcılar ──────────────────────────────────────────── */
  const $   = (sel, ctx = document) => ctx.querySelector(sel);
  const $$  = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const money = (cents) =>
    (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL';
  const stars = (r) => {
    r = parseFloat(r) || 0;
    return Array.from({ length: 5 }, (_, i) =>
      i < Math.floor(r) ? '★' : i < r ? '⯨' : '☆'
    ).join('');
  };
 
  /* ══════════════════════════════════════════════════════════
     STOREFRONT API
     Token'ı doğrudan meta tag'den okur.
     theme.liquid'e dokunmaya gerek yok.
  ══════════════════════════════════════════════════════════ */
  const StorefrontAPI = (() => {
    const token = $('meta[name="shopify-storefront-token"]')?.content || '';
    const shop  = SC.shop || window.Shopify?.shop || location.hostname;
    const url   = `https://${shop}/api/${API_VER}/graphql.json`;
 
    if (!token) console.warn('[Favorites] Storefront token bulunamadı.');
 
    async function gql(query, variables = {}) {
      if (!token) return null;
      try {
        const res = await fetch(url, {
          method : 'POST',
          headers: {
            'Content-Type'                      : 'application/json',
            'X-Shopify-Storefront-Access-Token' : token,
          },
          body: JSON.stringify({ query, variables }),
        });
        if (!res.ok) { console.warn('[Favorites] Storefront API HTTP:', res.status); return null; }
        return res.json();
      } catch (e) {
        console.warn('[Favorites] Storefront API hatası:', e);
        return null;
      }
    }
 
    return {
      token,
      shop,
 
      /* ────────────────────────────────────────────────────── *
       * Ürün sorgusu                                           *
       * /products/{handle}.js'den daha zengin veri döner.     *
       * ────────────────────────────────────────────────────── */
      async getProduct(handle) {
        const data = await gql(`
          query ProductByHandle($handle: String!) {
            product(handle: $handle) {
              handle title vendor availableForSale
              images(first: 1) { edges { node { url } } }
              variants(first: 50) {
                edges {
                  node {
                    id title availableForSale
                    price           { amount }
                    compareAtPrice  { amount }
                  }
                }
              }
            }
          }
        `, { handle });
 
        const p = data?.data?.product;
        if (!p) return null;
 
        /* buildCard'ın beklediği /products/*.js formatına normalize et */
        return {
          handle    : p.handle,
          title     : p.title,
          vendor    : p.vendor,
          available : p.availableForSale,
          images    : p.images.edges.map(e => ({ src: e.node.url })),
          variants  : p.variants.edges.map(({ node: v }) => ({
            id               : parseInt(v.id.split('/').pop(), 10),
            title            : v.title,
            available        : v.availableForSale,
            /* GraphQL fiyat: string "99.00" → buildCard cents bekler → * 100 */
            price            : Math.round(parseFloat(v.price.amount) * 100),
            compare_at_price : v.compareAtPrice
              ? Math.round(parseFloat(v.compareAtPrice.amount) * 100) : null,
          })),
          metafields: {},
        };
      },
 
      /* ────────────────────────────────────────────────────── *
       * Login mutation: email+pass → customerAccessToken       *
       * initLoginInterceptor() tarafından çağrılır.           *
       * ────────────────────────────────────────────────────── */
      async createCustomerToken(email, password) {
        const data = await gql(`
          mutation CreateToken($email: String!, $password: String!) {
            customerAccessTokenCreate(input: { email: $email, password: $password }) {
              customerAccessToken { accessToken expiresAt }
              customerUserErrors  { message }
            }
          }
        `, { email, password });
        return data?.data?.customerAccessTokenCreate?.customerAccessToken?.accessToken || null;
      },
 
      /* ────────────────────────────────────────────────────── *
       * Customer metafield OKU (Storefront API destekler)     *
       * ────────────────────────────────────────────────────── */
      async getCustomerHandles(customerAccessToken) {
        const data = await gql(`
          query CustomerFavs($cat: String!) {
            customer(customerAccessToken: $cat) {
              metafield(namespace: "favorites", key: "handles") { value }
            }
          }
        `, { cat: customerAccessToken });
 
        try {
          const raw = data?.data?.customer?.metafield?.value;
          return raw ? JSON.parse(raw) : [];
        } catch { return []; }
      },
 
      /* raw erişim (CustomerAPI kullanır) */
      gql,
    };
  })();
 
  /* ══════════════════════════════════════════════════════════
     CUSTOMER API
     Okuma  → Storefront API + customerAccessToken
     Yazma  → Customer Account API (yeni Shopify hesapları,
               window.Shopify.customerToken gerektirir)
  ══════════════════════════════════════════════════════════ */
  const CustomerAPI = (() => {
    const caUrl = `https://${StorefrontAPI.shop}/account/customer/api/${API_VER}/graphql`;
 
    /* localStorage'daki Storefront API customer access token */
    const getCAT  = () => localStorage.getItem(LS_CAT) || null;
 
    /* Yeni Customer Account API token (window.Shopify.customerToken) */
    const getCAAT = () => window.Shopify?.customerToken || null;
 
    async function caGql(query, variables = {}) {
      const token = getCAAT(); if (!token) return null;
      try {
        const res = await fetch(caUrl, {
          method : 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: token },
          body   : JSON.stringify({ query, variables }),
        });
        if (!res.ok) return null;
        return res.json();
      } catch { return null; }
    }
 
    return {
      isAvailable: () => !!(SC.loggedIn && (getCAT() || getCAAT())),
 
      async getHandles() {
        /* Önce Customer Account API (yeni hesaplar) */
        if (getCAAT()) {
          const data = await caGql(`query {
            customer { metafield(namespace:"favorites",key:"handles") { value } }
          }`);
          const raw = data?.data?.customer?.metafield?.value;
          if (raw !== undefined) return raw ? JSON.parse(raw) : [];
        }
 
        /* Sonra Storefront API + customer access token */
        const cat = getCAT();
        if (cat) return StorefrontAPI.getCustomerHandles(cat);
 
        return [];
      },
 
      async setHandles(handles) {
        /* Yöntem 1 — Customer Account API (yeni Shopify hesapları) */
        if (getCAAT()) {
          const data = await caGql(`
            mutation FavSet($metafields: [MetafieldsSetInput!]!) {
              metafieldsSet(metafields: $metafields) {
                metafields { key value }
                userErrors  { field message }
              }
            }
          `, {
            metafields: [{
              namespace : 'favorites',
              key       : 'handles',
              type      : 'json',
              value     : JSON.stringify(handles),
              ...(SC.id ? { ownerId: `gid://shopify/Customer/${SC.id}` } : {}),
            }],
          });
 
          const errs = data?.data?.metafieldsSet?.userErrors;
          if (!errs?.length) {
            console.debug('[Favorites] ✅ Metafield yazıldı (Customer Account API)');
            return true;
          }
          console.warn('[Favorites] Customer Account API hatası:', errs);
        }
 
        /* Yöntem 2 — Storefront API ile metafield YAZMA mümkün değil.
           Eski (classic) Shopify hesaplarında localStorage'da kalır.
           Çözüm: Shopify Admin → New Customer Accounts'ı etkinleştirin. */
        console.info('[Favorites] ℹ️ Sunucu sync için "New Customer Accounts" gerekli.');
        return false;
      },
    };
  })();
 
  /* ══════════════════════════════════════════════════════════
     LOGIN FORM INTERCEPT
     Müşteri giriş yaparken arka planda Storefront API'den
     customerAccessToken alınır ve localStorage'a kaydedilir.
     Normal form submit kesintisiz devam eder.
  ══════════════════════════════════════════════════════════ */
  function initLoginInterceptor() {
    const loginForm  = $('form[action*="/account/login"]');
    const logoutForm = $('form[action*="/account/logout"]');
 
    if (loginForm) {
      loginForm.addEventListener('submit', async () => {
        const email = loginForm.querySelector('[name="customer[email]"]')?.value;
        const pass  = loginForm.querySelector('[name="customer[password]"]')?.value;
        if (!email || !pass) return;
 
        /* Form submit olur; biz arka planda token alırız */
        StorefrontAPI.createCustomerToken(email, pass).then(token => {
          if (token) {
            localStorage.setItem(LS_CAT, token);
            console.debug('[Favorites] ✅ Customer access token kaydedildi');
          }
        });
      });
    }
 
    if (logoutForm) {
      logoutForm.addEventListener('submit', () => localStorage.removeItem(LS_CAT));
    }
  }
 
  /* ══════════════════════════════════════════════════════════
     METAFIELD SYNC
  ══════════════════════════════════════════════════════════ */
  const MetafieldSync = {
    _timer: null, _synced: false,
 
    scheduleSave() {
      if (!CustomerAPI.isAvailable()) return;
      clearTimeout(this._timer);
      this._timer = setTimeout(() => this._save(), 1500);
    },
 
    async _save() {
      await CustomerAPI.setHandles(Store.get().map(i => i.handle));
    },
 
    async init() {
      if (!CustomerAPI.isAvailable() || this._synced) return;
      this._synced = true;
      try {
        const server = await CustomerAPI.getHandles();
        if (!server?.length) return;
        const local = new Set(Store.get().map(i => i.handle));
        let changed = false;
        server.forEach(h => { if (!local.has(h)) { Store._addSilent(h, null, 0); changed = true; } });
        if (changed && $('#favList')) loadFavorites();
      } catch (e) { console.warn('[Favorites] Sync hatası:', e); }
    },
  };
 
  /* ══════════════════════════════════════════════════════════
     LOCALSTORAGE STORE
  ══════════════════════════════════════════════════════════ */
  const Store = {
    get()   { try { return JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch { return []; } },
    save(l) { localStorage.setItem(LS_KEY, JSON.stringify(l)); },
 
    add(handle, variantId, price) {
      const l = this.get().filter(i => i.handle !== handle);
      l.unshift({ handle, variantId, addedAt: Date.now(), addedPrice: price });
      this.save(l); MetafieldSync.scheduleSave();
    },
    _addSilent(handle, variantId, price) {
      const l = this.get().filter(i => i.handle !== handle);
      l.unshift({ handle, variantId, addedAt: Date.now(), addedPrice: price });
      this.save(l);
    },
    remove(handle) { this.save(this.get().filter(i => i.handle !== handle)); MetafieldSync.scheduleSave(); },
    has(handle)    { return this.get().some(i => i.handle === handle); },
    getItem(handle){ return this.get().find(i => i.handle === handle) || null; },
  };
 
  const RecentStore = {
    get()       { try { return JSON.parse(localStorage.getItem(LS_RECENT) || '[]'); } catch { return []; } },
    save(l)     { localStorage.setItem(LS_RECENT, JSON.stringify(l)); },
    add(handle) { const l = this.get().filter(i => i !== handle); l.unshift(handle); this.save(l.slice(0, 30)); },
  };
 
  /* ── Ürün verisi ──────────────────────────────────────────── */
  const ProductCache = {};
  async function fetchProduct(handle) {
    if (ProductCache[handle]) return ProductCache[handle];
 
    /* Storefront API önce (token varsa) */
    if (StorefrontAPI.token) {
      const p = await StorefrontAPI.getProduct(handle);
      if (p) { ProductCache[handle] = p; return p; }
    }
 
    /* Fallback: /products/{handle}.js */
    try {
      const r = await fetch(`/products/${handle}.js`);
      if (!r.ok) return null;
      const p = await r.json();
      ProductCache[handle] = p;
      return p;
    } catch { return null; }
  }
 
  /* ── Toast ────────────────────────────────────────────────── */
  const Toast = {
    el: null, timer: null,
    init() {
      this.el = $('#favToast');
      if (!this.el) {
        this.el = document.createElement('div');
        this.el.id = 'favToast';
        this.el.className = 'fav-toast';
        document.body.appendChild(this.el);
      }
    },
    show(msg, type = 'info', ms = 2400) {
      if (!this.el) this.init();
      this.el.textContent = msg;
      this.el.className = `fav-toast fav-toast--show fav-toast--${type}`;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.el.className = 'fav-toast'; }, ms);
    },
  };
 
  /* ── Kart oluşturucu ──────────────────────────────────────── */
  function buildCard(product, stored) {
    const tpl = $('#favCardTpl'); if (!tpl) return null;
    const card = tpl.content.cloneNode(true).querySelector('.fav-card');
 
    const variant     = product.variants.find(v => v.id == stored?.variantId) || product.variants[0];
    const price       = variant.price;
    const compare     = variant.compare_at_price;
    const hasDiscount = compare && compare > price;
 
    card.dataset.handle  = product.handle;
    card.dataset.variant = variant.id;
 
    const img = card.querySelector('.fav-card__img');
    img.src = product.images[0]?.src || ''; img.alt = product.title;
 
    if (hasDiscount) {
      const db = card.querySelector('.fav-card__discount');
      db.textContent = `-%${Math.round((1 - price / compare) * 100)}`;
      db.style.display = '';
    }
 
    card.querySelector('.fav-card__vendor').textContent = product.vendor || '';
    card.querySelector('.fav-card__title').textContent  = product.title;
 
    const rating  = parseFloat(product.metafields?.reviews?.rating) || (3.5 + Math.random() * 1.5);
    const reviews = product.metafields?.reviews?.count || Math.floor(Math.random() * 400 + 10);
    card.querySelector('.fav-card__stars').textContent   = stars(rating);
    card.querySelector('.fav-card__reviews').textContent = `(${reviews})`;
    card.querySelector('.fav-card__price').textContent   = money(price);
    if (hasDiscount) card.querySelector('.fav-card__compare').textContent = money(compare);
 
    if (stored?.addedPrice && stored.addedPrice !== price) {
      const ap = card.querySelector('.fav-card__added-price');
      ap.style.display = '';
      ap.querySelector('strong').textContent = money(stored.addedPrice);
    }
 
    card.querySelector('.fav-card__btn--cart').addEventListener('click', e => addToCart(variant.id, e.currentTarget));
 
    const sizeBtn = card.querySelector('.fav-card__btn--size');
    sizeBtn.textContent = product.variants.length > 1 ? 'Beden Seç' : 'Tek Ebat';
    sizeBtn.addEventListener('click', () => { window.location.href = `/products/${product.handle}`; });
 
    card.querySelector('.fav-card__heart').addEventListener('click', () => {
      Store.remove(product.handle);
      Object.assign(card.style, { opacity: '0', transform: 'translateX(-20px)', transition: 'all .3s ease' });
      setTimeout(() => { card.remove(); checkEmpty(); }, 300);
      Toast.show('❌ Favorilerden çıkarıldı');
      _syncAllHearts(product.handle, false);
    });
 
    card.style.animationDelay = `${(Math.random() * 0.15).toFixed(2)}s`;
    return card;
  }
 
  /* ── Sepete ekle ──────────────────────────────────────────── */
  async function addToCart(variantId, btn) {
    btn.classList.add('loading'); btn.textContent = '...';
    try {
      const r = await fetch(ROUTES.cart_add || '/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!r.ok) throw new Error();
      btn.textContent = '✓ Eklendi!'; btn.style.background = 'var(--fav-green)';
      Toast.show('✅ Ürün sepete eklendi!', 'success');
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(() => { btn.textContent = 'Sepete Ekle'; btn.style.background = ''; btn.classList.remove('loading'); }, 2000);
    } catch {
      btn.textContent = 'Hata!'; btn.style.background = 'var(--fav-red)';
      Toast.show('⚠️ Sepete eklenemedi', 'error');
      setTimeout(() => { btn.textContent = 'Sepete Ekle'; btn.style.background = ''; btn.classList.remove('loading'); }, 2000);
    }
  }
 
  function checkEmpty() {
    const list = $('#favList'); if (!list) return;
    if (!list.children.length) {
      const e = $('#favEmpty'); if (e) e.style.display = '';
      const s = $('#favSkeletons'); if (s) s.style.display = 'none';
    }
  }
 
  /* ── Filtre & Sıralama ────────────────────────────────────── */
  let allCards = [], activeFilter = 'all', activeSort = 'date_desc';
 
  function applyFilterSort() {
    const list = $('#favList'); if (!list) return;
    let items = [...allCards];
 
    if (activeFilter === 'sale') {
      items = items.filter(({ product, stored }) => {
        const v = product.variants.find(vv => vv.id == stored?.variantId) || product.variants[0];
        return v.compare_at_price && v.compare_at_price > v.price;
      });
    } else if (activeFilter === 'stock') {
      items = items.filter(({ product }) => product.available);
    }
 
    items.sort((a, b) => {
      const [pa, pb] = [a.product.variants[0].price, b.product.variants[0].price];
      switch (activeSort) {
        case 'price_asc':  return pa - pb;
        case 'price_desc': return pb - pa;
        case 'name_asc':   return a.product.title.localeCompare(b.product.title, 'tr');
        case 'date_asc':   return a.stored.addedAt - b.stored.addedAt;
        default:           return b.stored.addedAt - a.stored.addedAt;
      }
    });
 
    list.innerHTML = ''; items.forEach(({ el }) => list.appendChild(el));
    const cnt = $('#favCount'); if (cnt) cnt.textContent = `${items.length} ürün`;
  }
 
  function _syncAllHearts(handle, isFav) {
    $$(`[data-fav-handle="${handle}"]`).forEach(btn => {
      btn.classList.toggle('fav-active', isFav);
      btn.setAttribute('aria-pressed', String(isFav));
      btn.setAttribute('aria-label', isFav ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
  }
 
  /* ── Favorileri yükle ─────────────────────────────────────── */
  async function loadFavorites() {
    const list = $('#favList'); if (!list) return;
    const skel = $('#favSkeletons'), empty = $('#favEmpty');
    if (skel)  skel.style.display  = '';
    if (empty) empty.style.display = 'none';
    list.innerHTML = ''; allCards = [];
 
    const stored = Store.get();
    if (!stored.length) {
      if (skel)  skel.style.display  = 'none';
      if (empty) empty.style.display = '';
      const cnt = $('#favCount'); if (cnt) cnt.textContent = '0 ürün';
      return;
    }
 
    const results = await Promise.all(stored.map(s => fetchProduct(s.handle).then(p => ({ p, s }))));
    if (skel) skel.style.display = 'none';
 
    results.forEach(({ p, s }) => {
      if (!p) return;
      const el = buildCard(p, s); if (!el) return;
      list.appendChild(el);
      allCards.push({ el, product: p, stored: s });
    });
 
    applyFilterSort(); checkEmpty();
  }
 
  async function loadRecent() {
    const list = $('#recentList'); if (!list) return;
    const handles = RecentStore.get();
    if (!handles.length) { const e = $('#recentEmpty'); if (e) e.style.display = ''; return; }
    const results = await Promise.all(handles.slice(0, 20).map(fetchProduct));
    results.forEach((p, i) => {
      if (!p) return;
      const el = buildCard(p, { handle: p.handle, addedAt: Date.now() - i * 1000 });
      if (el) list.appendChild(el);
    });
  }
 
  function initTabs() {
    $$('.fav-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        $$('.fav-tab').forEach(t => t.classList.remove('fav-tab--active'));
        $$('.fav-panel').forEach(p => p.classList.remove('fav-panel--active'));
        tab.classList.add('fav-tab--active');
        $(`[data-panel="${tab.dataset.tab}"]`)?.classList.add('fav-panel--active');
        if (tab.dataset.tab === 'recently') loadRecent();
      });
    });
  }
 
  function initFilters() {
    $$('.fav-filter').forEach(btn => {
      btn.addEventListener('click', () => {
        $$('.fav-filter').forEach(b => b.classList.remove('fav-filter--active'));
        btn.classList.add('fav-filter--active');
        activeFilter = btn.dataset.filter; applyFilterSort();
      });
    });
  }
 
  function initSort() {
    const sel = $('#favSort'); if (!sel) return;
    sel.addEventListener('change', () => { activeSort = sel.value; applyFilterSort(); });
  }
 
  /* ══════════════════════════════════════════════════════════
     PUBLIC API  —  window.Favorites
  ══════════════════════════════════════════════════════════ */
  window.Favorites = {
    toggle(btn) {
      const handle    = btn.dataset.favHandle;
      const variantId = btn.dataset.favVariant || null;
      const price     = parseInt(btn.dataset.favPrice || '0', 10);
      if (!handle) return;
 
      const wasFav = Store.has(handle);
      if (wasFav) {
        Store.remove(handle);
        Toast.show('❌ Favorilerden çıkarıldı');
      } else {
        Store.add(handle, variantId, price);
        btn.classList.add('fav-heart-btn--popping');
        setTimeout(() => btn.classList.remove('fav-heart-btn--popping'), 500);
        Toast.show('❤️ Favorilere eklendi!', 'success');
      }
      _syncAllHearts(handle, !wasFav);
    },
    isFavorite : (handle) => Store.has(handle),
    add        : (handle, variantId, price) => Store.add(handle, variantId, price),
    remove     : (handle) => Store.remove(handle),
    trackView  : (handle) => RecentStore.add(handle),
  };
 
  /* ── DOMContentLoaded ─────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    Toast.init();
    initLoginInterceptor();
    MetafieldSync.init();
 
    $$('.fav-heart-btn').forEach(btn => {
      const handle = btn.dataset.favHandle; if (!handle) return;
      const isFav  = Store.has(handle);
      if (isFav !== btn.classList.contains('fav-active')) {
        btn.classList.toggle('fav-active', isFav);
        btn.setAttribute('aria-pressed', String(isFav));
      }
    });
 
    if (!$('#favoritesApp')) return;
    initTabs(); initFilters(); initSort(); loadFavorites();
    $('#newColBtn')?.addEventListener('click', () => Toast.show('🔖 Yakında gelecek!', 'info'));
  });
 
})();